import { InjectionToken } from '@angular/core';

import { environment } from '../../environment/environment';

export const ENV = new InjectionToken<typeof environment>('env');

export const APP_CONTEXT = new InjectionToken<{ appName: string, appVersion: string }>('app_context');
